import React from 'react'
import classes from './ContactUs.module.scss'
import DetailBox from './DetailBox'
import { faEnvelopeOpenText } from '@fortawesome/free-solid-svg-icons/faEnvelopeOpenText'

export default function ContactUs() {
	return (
		<div className={classes.root} id='contact-us'>
			<DetailBox
				title='Contact Us'
				icon={faEnvelopeOpenText}
			>
				<div className={classes.grid}>
					<div className={classes.col}>
						<h2>Call us</h2>
						<a href='tel:6096808025'>
							Tom @ (609) 680-8025
						</a>

						<h2>Email us</h2>
						<a href='mailto:tom@southjerseyfurniturerepair.com?subject=[Furniture Repair] Inquiry&body=Please describe your inquiry below:%0D%0A%0D%0A'>
							tom@southjerseyfurniturerepair.com
						</a>
					</div>

					<div className={classes.col}>
						<h2>Drop off to us</h2>
						<address>
							<strong>South Jersey Furniture Repair, LLC</strong><br/>
							535 Oak Ave<br/>
							Malaga, NJ 08328
						</address>
					</div>

					<iframe
						title='Google Map'
						className={classes.col}
						src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12298.551684904012!2d-75.0684519!3d39.59031!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x6407a496cf7cc773!2sSouth+Jersey+Furniture+Repair+LLC!5e0!3m2!1sen!2sus!4v1565613286405!5m2!1sen!2sus"
						allowFullScreen/>
				</div>
			</DetailBox>
		</div>
	)
}
